import { Injectable } from '@angular/core';
import { State, Selector, StateContext, NgxsOnInit, createSelector } from '@ngxs/store';
import { AcademyCourse, AcademyCourseSection } from '../models';

export interface AcademyStateModel {
  courses: AcademyCourse[];
}

const authors: any = {
ALLAN: {
    name: "Allan Blume",
    bio: "With over 45 years of experience in special education, Allan Blume has established himself as a thought leader in the field, specializing in guiding educators and parents through the transition to the new IEP format. Recognizing that while those who write IEPs are deeply committed to doing what is best for their students, they often find the process daunting, Allan developed the Blume Method to simplify and enhance IEP writing. This method provides practical tools, including formulas and sentence starters, to make the process more manageable, consistent across levels and buildings, and efficient, while preserving the critical principle of individualization at the heart of every IEP.",
    image: "allan.png",
    title: "IEP Specialist",
    educationTitle: "Ed-S",
    courses: [],
  },
  MARYELLEN: {
    name: "MaryEllen Bernier",
    bio: "MaryEllen has worked as an SLP for the last 22 years in various Massachusetts public school settings. For the last 12 years, she has worked in both Technical and Traditional High School settings. Prior to that, she worked in Elementary Schools for seven years, and a Middle School for three years. She and her husband, Ken, are the proud parents of three children ages 16,18 and 20 and two beloved dogs.  MaryEllen is passionate about supporting the communication needs of her students, helping them to realize their strengths, and growing their self-advocacy.",
    image: "maryellen.png",
    title: "Speech and Language Pathologist",
    educationTitle: "MA CCC-SLP",
    courses: [],
  },
  CHUCK: {
    name: "Chuck Zucco",
    bio: "Chuck is a special educator with over 45 years of experience. Chuck has a passion for helping educators and parents navigate the transition to the new IEP format.",
    image: "chuck.jpg",
    title: "SpEd Case Manager",
    educationTitle: "MSW",
    courses: [],
  },
  JARROD: {
    name: "Jarrod Scalzo",
    bio: "After graduating from the University of Connecticut in 2005, Jarrod entered the special education field specializing in autism education. Jarrod received a Master’s degree in Special Education from Simmons College in 2009 and became a Board Certified Behavior Analyst in 2014. Jarrod has specialized in staff training and professional development for more than 13 years in his role at the New England Center for Children. This includes onboarding new staff and supporting existing staff and their ongoing development as they work to become successful teachers and clinicians. He is well versed in a variety of topics pertaining to Applied Behavior Analysis and IEP development and looks forward to providing Blume Method clients a high level of support and expertise.",
    image: "jarrod.jpeg",
    title: "Behavior Analyst",
    educationTitle: "MSEd, BCBA, LABA",
    courses: [],
  },
  COLLEEN: {
    name: "Colleen Dorsey",
    bio: "Colleen is a special educator with over 45 years of experience. Colleen has a passion for helping educators and parents navigate the transition to the new IEP format.",
    image: "colleen.jpeg",
    title: "Special Educator",
    educationTitle: "",
    courses: [],
  },
  ALEX: {
    name: "Alex Caldwell",
    bio: "Alexandra Caldwell (she/her) has been a Special Education Teacher for more than 21 years. The majority of those years have been spent in early ed special education with a focus on students with Autism. She holds a Masters degree in education, and graduate certificates in Autism Studies and Applied Behavior Analyses. She currently teaches a full-day substantially separate preschool program in Bourne, MA. Alexandra has spent countless hours taking data and writing IEPs based on her students’ needs. Her strong advocacy skills reach far beyond the classroom, as she is passionate about speaking up for equal rights and fighting for those with less privilege. She lives with her wife, three children, and many pets on Cape Cod.",
    image: "alex.jpeg",
    title: "Special Educator",
    educationTitle: "",
  },
  REBECCA: {
    name: "Rebecca Cann",
    bio: "Rebecca Cann, M.A., CCC-SLP, is a seasoned Speech-Language Pathologist and special education consultant specializing in augmentative and alternative communication (AAC), Multi-Tiered Systems of Support (MTSS), and inclusive education for PreK–22 public schools. As the founder of Inclusive Educational Consulting, PLLC, she partners with districts to improve communication access, instructional practices, and support for students with complex needs. Rebecca provides AAC assessments, professional development, coaching, and collaborative problem-solving, working closely with educators and administrators to implement evidence-based strategies. She is a TouchChat Certified Trainer, holds a special education administrator license, and is trained in oromyofunctional therapy and the sensory oral sequential approach to feeding.",
    image: "rebecca.jpeg",
    title: "Special Educator",
    educationTitle: "MA, CCC-SLP",
  },
  MICHAEL: {
    name: "Michael Vanderlaine",
    bio: `Michael Vanderlaine is an educational leader specializing in school climate and culture by building Multi-Tiered Systems of Support that strives to create equitable outcomes for all learners. As a scholar-practitioner he operationalizes current research using a systems-thinking approach parodied with paired his unique perspective as a former creative and performing arts educator. As a school leader he strives to support the conditions for collaborative solutions to increase achievement, through authentic deeper learning experiences that engage all members of a learning community. With an emphasis for inclusion and equity he serves learning communities to support innovative, creative, and collaborative solutions for leaders and learners as they embark on an odyssey of learning and discovery that welcomes caregivers, educators, and community members into the discourse of contemporary education.`,
    image: "michael.jpg",
    title: "Building",
    educationTitle: "",
  },

  URBAN_DISTRICT_MID_LEVEL_TEAM: {
    name: "Urban District Mid-Level Team",
    bio: "Pamela Lang-Moszka, Dawnmarie Reardon, Gabriella Masse, and Grace Kerr are members of an Urban District Mid-level Leadership Team in Massachusetts. As a team of special educators, they have introduced an innovative model designed to strengthen and enhance their district’s special education system.",
    image: "urban-district-mid-level-team.png",
    title: "Urban District Mid-Level Team",
    educationTitle: "Special Educators",
  },

  KATIE: {
    name: "Katie Norregaard",
    bio: "Katie  has over 10 years of experience teaching students with severe/complex  special needs. Recently, Katie went back to school for vision studies and now works as a Teacher of the Visually impaired for different schools and districts across Massachusetts. She currently supports students ages 3–21, providing individualized instruction, and collaborating with families and school teams to ensure meaningful access to learning. Katie is passionate about promoting independence, accessibility, and inclusion for students with complex needs and visual impairments.",
    image: "katie.jpg",
    title: "Special Educator",
    educationTitle: "",
  },

  BILL: {
    name: "Bill Fuller",
    bio: "Bill Fuller is a dedicated educator with extensive experience supporting students across a wide range of academic, social, and emotional needs. His career in education began at the Italian Home for Children, a residential and day school serving students with social and emotional impairments, where he worked as a direct care counselor, classroom teacher, and supervisor.",
    image: "bill.png",
    title: "Educator",
    educationTitle: "",
  },

  MARIAH: {
    name: "Mariah Palaez",
    bio: "Mariah is a mental health advocate and educator. Taking time to understand my students has changed my life. One of my favorite quotations, \"If you feel you do not belong in this world, it is because you are here to create a better one.\"",
    image: "mariah.png",
    title: "Educator",
    educationTitle: "B.A.",
  },

  TBD: {
    name: "TBD",
    bio: "Author information will be available closer to the release date of this topic.",
    image: null,
    title: null,
    educationTitle: null,
  },
};

const defaults: AcademyStateModel = {
  courses: [
{
      id: "introduction-to-the-new-iep",
      name: "Introduction to the 2024 IEP",
      status: "published",
      authors: [authors.ALLAN],
      categories: ["Pedagogy", "Subject Matter Knowledge", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 1,
      pdPoints: 2,
      description: "An overview of each section of the new Massachusetts IEP.",
      active: true,
      sections: [
        {
          id: "introduction",
          type: "video",
          name: "Introduction",
          description: "A brief introduction to the new IEP.",
          videoLength: "5:55",
          videoUrl: "https://vimeo.com/video/949159453",
          playlistIndex: 1,
        },
        {
          id: "concerns-and-vision",
          type: "video",
          name: "Concerns & Vision",
          description:
            "A deep dive into the student/parent concerns & vision section of the IEP.",
          videoLength: "1:58",
          videoUrl: "https://vimeo.com/video/949161798",
          playlistIndex: 2,
        },
        {
          id: "student-profile",
          type: "video",
          name: "Student Profile",
          description:
            "An overview of the Student Profile and Disability sections of the IEP.",
          videoLength: "2:40",
          videoUrl: "https://vimeo.com/video/949161528",
          playlistIndex: 3,
        },
        {
          id: "present-levels",
          type: "video",
          name: "Present-Levels",
          description: "An overview of the Present Levels sections of the IEP.",
          videoLength: "5:19",
          videoUrl: "https://vimeo.com/video/949161194",
          playlistIndex: 4,
        },
        {
          id: "transition-planning",
          type: "video",
          name: "Transition Planning",
          description:
            "An overview of the Transition Planning section of the IEP.",
          videoLength: "3:22",
          videoUrl: "https://vimeo.com/video/949160981",
          playlistIndex: 5,
        },
        {
          id: "accommodations-and-modifications",
          type: "video",
          name: "Accommodations & Modifications",
          description:
            "An overview of the Accommodtions & Modificataions sections of the IEP.",
          videoLength: "2:22",
          videoUrl: "https://vimeo.com/video/949160814",
          playlistIndex: 6,
        },
        {
          id: "state-and-district-assessments",
          type: "video",
          name: "State & District Assessments",
          description:
            "An overview of the State/District Assessments sections of the IEP.",
          videoLength: "1:15",
          videoUrl: "https://vimeo.com/video/949160736",
          playlistIndex: 7,
        },
        {
          id: "goals-and-objectives",
          type: "video",
          name: "Goals & Objectives",
          description:
            "An overview of the Goals & Objectives sections of the IEP.",
          videoLength: "2:15",
          videoUrl: "https://vimeo.com/video/949160610",
          playlistIndex: 8,
        },
        {
          id: "service-delivery",
          type: "video",
          name: "Service Delivery",
          description:
            "An overview of the Service Delivery section of the IEP.",
          videoLength: "1:57",
          videoUrl: "https://vimeo.com/video/949160471",
          playlistIndex: 9,
        },
        {
          id: "schedule-modifications",
          type: "video",
          name: "Schedule Modifications",
          description:
            "An overview of the Schedule Modifications section of the IEP.",
          videoLength: "1:30",
          videoUrl: "https://vimeo.com/video/949160339",
          playlistIndex: 10,
        },
        {
          id: "additional-info",
          type: "video",
          name: "Additional Info",
          description:
            "An overview of the Additional Information section of the IEP.",
          videoLength: "2:36",
          videoUrl: "https://vimeo.com/video/949160083",
          playlistIndex: 11,
        },
      ],
    },
    {
      id: "deep-dive-into-the-new-iep",
      name: "Deep Dive: 2024 IEP",
      status: "published",
      authors: [authors.ALLAN],
      categories: ["Pedagogy", "Subject Matter Knowledge", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 2,
      description: "A deep dive into the new Massachusetts IEP.",
      pdPoints: 4,
      active: true,
      sections: [
        {
          id: "introduction",
          type: "video",
          name: "Introduction",
          description:
            "An overview of the 2024 Massachusetts IEP, highlighting its purpose, structure, key updates, and the roles of parents, educators, and stakeholders in creating effective, individualized education plans.",
          videoLength: "1:37",
          videoUrl: "https://vimeo.com/video/939710696",
          playlistIndex: 1,
        },
        {
          id: "concerns-and-vision",
          type: "video",
          name: "Concerns & Vision",
          description:
            "How to articulate and document student concerns and long-term vision, ensuring the IEP aligns with the student's aspirations and addresses their unique challenges.",
          videoLength: "6:14",
          videoUrl: "https://vimeo.com/video/941960094",
          playlistIndex: 2,
        },
        {
          id: "present-levels",
          type: "video",
          name: "Present-Levels",
          description:
            "How to accurately document a student's current academic and functional performance, providing a baseline for setting realistic and achievable goals in the IEP.",
          videoLength: "18:25",
          videoUrl: "https://vimeo.com/video/939608233",
          playlistIndex: 3,
        },
        {
          id: "accommodations",
          type: "video",
          name: "Accommodations",
          description:
            "Outline of the various accommodations available to support student learning and participation, ensuring access to the general education curriculum and environment.",
          videoLength: "8:50",
          videoUrl: "https://vimeo.com/video/939620514",
          playlistIndex: 4,
        },
        {
          id: "specially-designed-instruction",
          type: "video",
          name: "Specially Designed Instruction",
          description:
            "How to create and implement instructional strategies tailored to meet the unique learning needs of each student as outlined in their IEP.",
          videoLength: "3:20",
          videoUrl: "https://vimeo.com/video/941960152",
          playlistIndex: 5,
        },
        {
          id: "content-modifications",
          type: "video",
          name: "Content Modifications",
          description:
            "How to adjust and modify curriculum content to align with the student’s abilities, ensuring they can access and engage with the material meaningfully.",
          videoLength: "14:25",
          videoUrl: "https://vimeo.com/video/940497031",
          playlistIndex: 6,
        },
        {
          id: "methodology-modifications",
          type: "video",
          name: "Methodology Modifications",
          description:
            "Explanation of the changes in teaching methods and instructional approaches designed to better support individual learning styles and needs within the classroom setting.",
          videoLength: "11:46",
          videoUrl: "https://vimeo.com/video/939703892",
          playlistIndex: 7,
        },
        {
          id: "performance-criteria-student-output",
          type: "video",
          name: "Performance Criteria/Student Output",
          description:
            "How to establish and measure performance criteria to evaluate student progress, ensuring goals and objectives are met effectively.",
          videoLength: "6:09",
          videoUrl: "https://vimeo.com/video/940519874",
          playlistIndex: 8,
        },
        {
          id: "baseline",
          type: "video",
          name: "Baseline",
          description:
            "How to establish a starting point for tracking student progress, providing a reference for measuring growth and setting future goals",
          videoLength: "13:14",
          videoUrl: "https://vimeo.com/video/939707399",
          playlistIndex: 9,
        },
        {
          id: "goals-and-objectives",
          type: "video",
          name: "Goals & Objectives",
          description:
            "Develop specific, measurable, achievable, relevant, and time-bound (SMART) goals and objectives to promote student growth and success.",
          videoLength: "20:39",
          videoUrl: "https://vimeo.com/video/941441876",
          playlistIndex: 10,
        },
        {
          id: "educational-assessment",
          type: "video",
          name: "Educational Assessment",
          description:
            "Review of various assessment methods and tools used to inform the development and ongoing revisions of the IEP, ensuring it meets the student’s evolving needs.",
          videoLength: "4:55",
          videoUrl: "https://vimeo.com/video/941959816",
          playlistIndex: 11,
        },
        {
          id: "eligibility",
          type: "video",
          name: "Eligibility",
          description: "An overview of the eligibility criteria for an IEP.",
          videoLength: "5:56",
          videoUrl: "https://vimeo.com/video/941596307",
          playlistIndex: 12,
        },
      ],
    },
    {
      id: "history-of-special-ed",
      name: "History of Special Ed",
      status: "published",
      authors: [authors.ALLAN],
      categories: ["Pedagogy", "Subject Matter Knowledge", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 3,
      pdPoints: 2,
      description:
        "Allan Blume presents an overview of the history of special education in the United States.",
      active: true,
      sections: [
        {
          id: "history-of-special-ed",
          type: "video",
          name: "History of Special Ed",
          description:
            "Allan Blume presents an overview of the history of special education in the United States.",
          videoLength: "21:58",
          videoUrl: "https://vimeo.com/video/1049984478",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "running-an-effective-iep-meeting",
      name: "Running an Effective IEP Meeting",
      status: "published",
      authors: [authors.CHUCK],
      categories: ["Subject Matter Knowledge", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 4,
      pdPoints: 3,
      description:
        "Chuck Zucco teaches you how to run an effective IEP meeting.",
      active: true,
      sections: [
        {
          id: "running-an-effective-iep-meeting-part-1",
          type: "video",
          name: "Running an Effective IEP Meeting Part 1",
          description:
            "Chuck Zucco teaches you how to run an effective IEP meeting.",
          videoLength: "17:39",
          videoUrl: "https://vimeo.com/video/1061607277",
          playlistIndex: 1,
        },
        {
          id: "running-an-effective-iep-meeting-part-2",
          type: "video",
          name: "Running an Effective IEP Meeting Part 2",
          description:
            "Chuck Zucco teaches you how to run an effective IEP meeting.",
          videoLength: "31:32",
          videoUrl: "https://vimeo.com/video/1049989221",
          playlistIndex: 2,
        },
      ],
    },
    {
      id: "every-student-has-a-voice",
      name: "Every Student Has a Voice",
      status: "published",
      authors: [authors.COLLEEN],
      categories: ["Pedagogy", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 6,
      pdPoints: 2,
      description:
        "Empower every student to be heard in this inspiring topic focused on fostering communication and self-expression. Learn strategies to support diverse learners, promote inclusive practices, and create environments where all voices matter. Perfect for educators who want to help students build confidence, advocate for themselves, and thrive both in and out of the classroom.",
      active: true,
      sections: [
        {
          id: "every-student-has-a-voice",
          type: "video",
          name: "Every Student Has a Voice",
          description:
            "Colleen discusses the importance of the student's voice when writing the IEP.",
          videoLength: "8:26",
          videoUrl: "https://vimeo.com/video/1052022157",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "applied-behavior-analysis-and-the-iep",
      name: "Applied Behavior Analysis & The IEP",
      status: "upcoming",
      authors: [authors.JARROD],
      publishDate: "Feb 25th",
      categories: ["Pedagogy", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 5,
      pdPoints: 2,
      description:
        "Ready to make ABA work with the IEP? This topic is all about connecting the dots between Applied Behavior Analysis strategies and meaningful IEP development. We’ll break down how ABA principles can support student goals, tackle challenging behaviors, and promote real progress. Whether you’re new to ABA or looking to strengthen your approach, this practical, hands-on topic will help you build IEPs that are data-driven, individualized, and focused on success.",
      active: true,
      sections: [
        {
          id: "applied-behavior-analysis-and-the-iep",
          type: "video",
          name: "Applied Behavior Analysis & The IEP",
          description:
            "Jarrod Scalzo breaks down how ABA principles can support student goals, tackle challenging behaviors, and promote real progress.",
          videoLength: "7:55",
          videoUrl: "https://vimeo.com/video/1059921093",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "ieps-for-english-learners",
      name: "IEPs for English Learners",
      status: "published",
      authors: [authors.ALLAN],
      publishDate: "Mar 25th",
      categories: ["Training Strategies", "Elective"],
      learnerTypes: [
        "General Educators",
        "Special Educators",
        "Leaders",
        "RSPs",
      ],
      playlistIndex: 7,
      pdPoints: 2,
      description:
        "Allan Blume presents on English Learners (EL) and Special Education.",
      active: true,
      sections: [
        {
          id: "ieps-for-english-learners",
          type: "video",
          name: "IEPs for English Learners",
          description:
            "This topic explores the intersection of language acquisition and special education, including differentiating between language learning needs and learning disabilities.",
          videoLength: "10:13",
          videoUrl: "https://vimeo.com/video/1068935765",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "how-do-communication-needs-find-their-way-into-the-iep",
      name: "How Communication Needs find their way into an IEP",
      status: "published",
      authors: [authors.MARYELLEN],
      publishDate: "Mar 25th",
      categories: ["Pedagogy", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 8,
      pdPoints: 3,
      description:
        "Designed for those who are writing the 2024 IEP, a Speech Language Pathologist offers her perspective on the new IEP while identifying areas in which the SLP will directly contribute to and write portions of the IEP and also by highlighting areas of the new IEP in which consultation with the SLP may be warranted to best articulate and consider communication needs.",
      active: true,
      sections: [
        {
          id: "how-do-communication-needs-find-their-way-into-the-iep-part-1",
          type: "video",
          name: "Understanding Communication Disorders",
          description:
            "An overview of communication disorders, including definitions from ASHA, IDEA, and DESE, with examples to enhance understanding. 1/4",
          videoLength: "18:42",
          videoUrl: "https://vimeo.com/video/1068907985",
          playlistIndex: 1,
        },
        {
          id: "how-do-communication-needs-find-their-way-into-the-iep-part-2",
          type: "video",
          name: "SLP Contributions to IEP Sections",
          description:
            "Exploring how SLPs can support Student/Parent Concerns, Vision, Present Levels, and Transitions in IEPs, either directly or through consultation. 2/4",
          videoLength: "17:16",
          videoUrl: "https://vimeo.com/video/1068909771",
          playlistIndex: 2,
        },
        {
          id: "how-do-communication-needs-find-their-way-into-the-iep-part-3",
          type: "video",
          name: "Communication in Accommodations vs. Modifications",
          description:
            "Clarifying the difference between accommodations and modifications, with communication-specific examples of each. 3/4",
          videoLength: "7:10",
          videoUrl: "https://vimeo.com/video/1068911450",
          playlistIndex: 3,
        },
        {
          id: "how-do-communication-needs-find-their-way-into-the-iep-part-4",
          type: "video",
          name: "Developing Effective Communication Goals",
          description:
            "A step-by-step guide on creating Baselines, Goals, and Objectives/Benchmarks to address students' communication needs. 4/4",
          videoLength: "8:31",
          videoUrl: "https://vimeo.com/video/1068912382",
          playlistIndex: 4,
        },
      ],
    },
    {
      id: "ed-assessment-vs-ed-summary",
      name: "Ed Assessment vs Ed Summary",
      status: "published",
      authors: [authors.ALLAN],
      publishDate: "Apr 29th",
      categories: ["Pedagogy", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 9,
      pdPoints: 2,
      description:
        "What's the difference between an educational assessment and an educational summary? This topic breaks it down clearly, helping you understand their unique purposes, when to use each, and how they work together to support student success. Packed with practical examples and tips, it's perfect for educators and specialists looking to sharpen their evaluation and reporting skills.",
      active: true,
      sections: [
        {
          id: "ed-assessment-vs-ed-summary",
          type: "video",
          name: "Ed Assessment vs Ed Summary",
          description:
            "This topic aims to promote understanding the experiences and challenges faced by individuals with disabilities and how this understanding could influence accommodations and modifications.",
          videoLength: "16:07",
          videoUrl: "https://vimeo.com/video/1077700745",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "eligibility-for-special-education",
      name: "Eligibility for Special Education",
      status: "published",
      authors: [authors.ALLAN],
      publishDate: "Apr 29th",
      categories: ["Training Strategies", "Elective"],
      learnerTypes: [
        "General Educators",
        "Special Educators",
        "Leaders",
        "RSPs",
      ],
      playlistIndex: 10,
      pdPoints: 2,
      description: "Allan Blume presents on Eligibility for Special Education.",
      active: true,
      sections: [
        {
          id: "eligibility",
          type: "video",
          name: "Eligibility",
          description:
            "Learn more about eligibility in Special Education. This topic breaks down how eligibility is determined, including what Massachusetts says, who determines it, the eligibility flowchart, and the ED-1.",
          videoLength: "11:23",
          videoUrl: "https://vimeo.com/video/1077699920",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "explicit-and-implicit-curriculum",
      name: "Explicit & Implicit Curriculum",
      status: "published",
      authors: [authors.ALLAN],
      publishDate: "May 27th",
      categories: ["Pedagogy", "Subject Matter Knowledge", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 11,
      pdPoints: 1,
      description:
        "Unpack the difference between what's taught and what's caught in this engaging topic on explicit and implicit curriculum. Explore how intentional instruction aligns with the unspoken lessons students absorb through classroom culture, interactions, and environment. Gain insights and strategies to create a balanced approach that supports both academic goals and social-emotional growth. Perfect for educators looking to deepen their impact!",
      active: true,
      sections: [
        {
          id: "explicit-and-implicit-curriculum",
          type: "video",
          name: "Explicit & Implicit Curriculum",
          description:
            "Unpack the difference between what’s taught and what’s caught in this engaging topic on explicit and implicit curriculum.",
          videoLength: "4:56",
          videoUrl: "https://vimeo.com/video/1087828931",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "writing-an-initial-iep",
      name: "Writing an Initial IEP",
      status: "published",
      authors: [authors.ALEX],
      publishDate: "May 27th",
      categories: [
        "Pedagogy",
        "Subject Matter Knowledge",
        "Elective",
        "Training Strategies",
      ],
      learnerTypes: [
        "General Educators",
        "Special Educators",
        "Related Service Providers",
      ],
      playlistIndex: 11,
      pdPoints: 2,
      description:
        "This topic explores the unique challenges that come with writing an initial IEP for young learners transitioning out of Early Intervention.",
      active: true,
      sections: [
        {
          id: "writing-an-initial-iep",
          type: "video",
          name: "Writing an Initial IEP",
          description:
            "This topic explores the unique challenges that come with writing an initial IEP for young learners transitioning out of Early Intervention.",
          videoLength: "9:13",
          videoUrl: "https://vimeo.com/video/1087831334",
          playlistIndex: 1,
        },
        {
          id: "baseline-recap",
          type: "video",
          name: "Baseline Recap",
          description:
            "A recap on how to write an objective, consistent, and measurable baseline.",
          videoLength: "6:38",
          videoUrl: "https://vimeo.com/video/1087831797",
          playlistIndex: 2,
        },
      ],
    },
    {
      id: "intro-to-aac",
      name: "Intro to AAC",
      status: "published",
      authors: [authors.REBECCA],
      publishDate: "Jun 24th",
      categories: [
        "Pedagogy",
        "Subject Matter Knowledge",
        "Elective",
        "Training Strategies",
      ],
      learnerTypes: ["Special Educators", "Related Service Providers"],
      playlistIndex: 1,
      pdPoints: 3,
      description:
        "This Introduction to Augmentative and Alternative Communication (AAC) course provides a foundational understanding of AAC, including its purpose, who it serves, and its role in supporting individuals with complex communication needs. Participants will explore different types of AAC systems, ranging from low-tech to high-tech solutions, and learn how they can be implemented in various educational settings. The course will also cover key considerations for school-based implementation, including assessment, intervention strategies, and collaboration among educators, therapists, and families. Through interactive discussions and case studies, learners will gain practical insights to effectively support AAC users in diverse learning environments.",
      active: true,
      sections: [
        {
          id: "intro-to-aac-1",
          type: "video",
          name: "Intro to AAC Part 1",
          description:
            "This Introduction to Augmentative and Alternative Communication (AAC) course provides a foundational understanding of AAC, including its purpose, who it serves, and its role in supporting individuals with complex communication needs. Participants will explore different types of AAC systems, ranging from low-tech to high-tech solutions, and learn how they can be implemented in various educational settings. The course will also cover key considerations for school-based implementation, including assessment, intervention strategies, and collaboration among educators, therapists, and families. Through interactive discussions and case studies, learners will gain practical insights to effectively support AAC users in diverse learning environments.",
          videoLength: "12:44",
          videoUrl: "https://vimeo.com/video/1095718525",
          playlistIndex: 1,
        },
        {
          id: "intro-to-aac-2",
          type: "video",
          name: "Intro to AAC Part 2",
          description: "Part 2 of our Intro to AAC topic.",
          videoLength: "07:29",
          videoUrl: "https://vimeo.com/video/1095722679",
          playlistIndex: 2,
        },
        {
          id: "intro-to-aac-3",
          type: "video",
          name: "Intro to AAC Part 3",
          description: "Part 3 of our Intro to AAC topic.",
          videoLength: "06:50",
          videoUrl: "https://vimeo.com/video/1095723700",
          playlistIndex: 3,
        },
        {
          id: "intro-to-aac-4",
          type: "video",
          name: "Intro to AAC Part 4",
          description: "Part 4 of our Intro to AAC topic.",
          videoLength: "04:37",
          videoUrl: "https://vimeo.com/video/1095721829",
          playlistIndex: 4,
        },
      ],
    },
    {
      id: "applied-behavior-analysis-and-the-iep-2",
      name: "Applied Behavior Analysis & The IEP II",
      status: "published",
      authors: [authors.JARROD],
      publishDate: "Jul 29th",
      categories: [
        "Pedagogy",
        "Subject Matter Knowledge",
        "Elective",
        "Training Strategies",
      ],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Parents",
        "Leaders",
      ],
      playlistIndex: 1,
      pdPoints: 3,
      description:
        "This topic explains why understanding visual inspection is important, and how it helps to inform decisions made by teachers and clinicians.",
      active: true,
      sections: [
        {
          id: "data-collection-methods",
          type: "video",
          name: "Data Collection Methods",
          description:
            "This section explains why understanding data collection methods is important, and how it helps to inform decisions made by teachers and clinicians. PLEASE NOTE: At the Blume Method we are experimenting with new and innovative ways of delivering content. This videos blends in-person recordings with AI voice-generated content, written and edited by our Special Ed professionals.",
          videoLength: "09:54",
          videoUrl: "https://vimeo.com/video/1105068171",
          playlistIndex: 1,
        },
        {
          id: "visual-inspection",
          type: "video",
          name: "Visual Inspection",
          description:
            "This section explains why understanding visual inspection is important, and how it helps to inform decisions made by teachers and clinicians. PLEASE NOTE: At the Blume Method we are experimenting with new and innovative ways of delivering content. This videos blends in-person recordings with AI voice-generated content, written and edited by our Special Ed professionals.",
          videoLength: "09:35",
          videoUrl: "https://vimeo.com/video/1105068903",
          playlistIndex: 2,
        },
        {
          id: "reinforcement-principles",
          type: "video",
          name: "Reinforcement Principles",
          description:
            "This section covers how the principles of reinforcement of impacts student behavior.  Starting with common terminology and definitions, including operant behavior, the properties of reinforcement, reinforcement versus punishment, unconditioned vs. conditioned reinforcers, and the three term contingency. PLEASE NOTE: At the Blume Method we are experimenting with new and innovative ways of delivering content. This videos blends in-person recordings with AI voice-generated content, written and edited by our Special Ed professionals.",
          videoLength: "09:55",
          videoUrl: "https://vimeo.com/video/1105068509",
          playlistIndex: 3,
        },
      ],
    },
    {
      id: "mtss",
      name: "Foundations of MTSS",
      authors: [authors.MICHAEL, authors.REBECCA],
      publishDate: "Aug 26th",
      categories: ["Subject Matter Knowledge", "Elective"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Leaders",
        "Parents",
      ],
      playlistIndex: null,
      pdPoints: 2,
      description:
        "A foundational overview of Multi Tiered Systems of Support (MTSS) is provided by clearly defining each tier and establishing shared MTSS terminology. The focus is on building a common language and understanding across roles, so participants can clearly distinguish Tier 1, Tier 2, and Tier 3 supports and how they function within a districtwide framework. Using perspectives from administration, general education, special education, and related services, the content specialists ground the discussion in real school based examples.",
      active: true,
      sections: [
        {
          id: "mtss-1",
          type: "video",
          name: "MTSS Intro",
          description:
            "This section introduces the concept of MTSS, its definition, and its purpose.",
          videoLength: "06:30",
          videoUrl: "https://vimeo.com/video/1112843508",
          playlistIndex: 1,
        },
        {
          id: "mtss-2",
          type: "video",
          name: "Tier 1",
          description: "This section discusses the first tier of MTSS.",
          videoLength: "11:25",
          videoUrl: "https://vimeo.com/video/1112845421",
          playlistIndex: 2,
        },
        {
          id: "mtss-3",
          type: "video",
          name: "Tier 2",
          description: "This section discusses the second tier of MTSS.",
          videoLength: "12:30",
          videoUrl: "https://vimeo.com/video/1112844696",
          playlistIndex: 3,
        },
        {
          id: "mtss-4",
          type: "video",
          name: "Tier 3",
          description:
            "This section introduces the concept of MTSS, its definition, and its purpose.",
          videoLength: "18:00",
          videoUrl: "https://vimeo.com/video/1112843821",
          playlistIndex: 4,
        },
      ],
    },
    {
      id: "defining-modifications",
      name: "Defining Modifications",
      status: "published",
      authors: [authors.ALLAN],
      categories: ["Pedagogy", "Subject Matter Knowledge", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 3,
      pdPoints: 1,
      description:
        "This video highlights why IEP goals must be based on a student’s disability-related needs rather than tied to curriculum standards or specific service areas.",
      active: true,
      sections: [
        {
          id: "defining-modifications",
          type: "video",
          name: "Defining Modifications",
          description:
            "This video highlights why IEP goals must be based on a student’s disability-related needs rather than tied to curriculum standards or specific service areas.",
          videoLength: "12:15",
          videoUrl: "https://vimeo.com/video/1122974521",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "mathematics-content-vs-math-skills",
      name: "Mathematics Content vs. Math Skills",
      status: "published",
      authors: [authors.ALLAN],
      categories: ["Pedagogy", "Subject Matter Knowledge", "Elective"],
      learnerTypes: ["General Educators", "Special Educators"],
      playlistIndex: 3,
      pdPoints: 1,
      description:
        "This video explores the difference between math content (the grade-level curriculum topics students are expected to learn) and math skills (the foundational abilities like problem-solving, number sense, and reasoning needed to succeed with that content).",
      active: true,
      sections: [
        {
          id: "mathematics-content-vs-math-skills",
          type: "video",
          name: "Mathematics Content vs. Math Skills",
          description:
            "This video explores the difference between math content (the grade-level curriculum topics students are expected to learn) and math skills (the foundational abilities like problem-solving, number sense, and reasoning needed to succeed with that content).",
          videoLength: "21:05",
          videoUrl: "https://vimeo.com/video/1122974621",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "goals-based-on-needs",
      name: "Goals Based on Need, Not Curriculum",
      status: "published",
      authors: [authors.ALLAN],
      publishDate: "Oct 27th",
      categories: ["Subject Matter Knowledge", "Elective"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Leaders",
        "Parents",
      ],
      playlistIndex: null,
      pdPoints: 1,
      description:
        "This course will discuss the role of goals based on need, not curriculum.",
      active: true,
      sections: [
        {
          id: "goals-based-on-needs",
          type: "video",
          name: "Goals Based on Needs, Not Curriculum",
          description:
            "This video highlights why IEP goals must be based on a student's disability-related needs, rather than tied to curriculum standards or specific service areas.",
          videoLength: "10:40",
          videoUrl: "https://vimeo.com/video/1130513044",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "severe-special-education-iep-goals",
      name: "Severe Special Education IEP Goals",
      status: "coming soon",
      authors: [authors.TBD],
      publishDate: "TBD",
      categories: [
        "Subject Matter Knowledge",
        "Elective",
        "Training Strategies",
      ],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Leaders",
        "Parents",
      ],
      playlistIndex: null,
      pdPoints: 2,
      description:
        "This topic covers how to write IEPs for students in substantially separate severe special education programs/classes and the method behind the decision and creation of each goal. There is a public school special education mentality of aligning with curriculums and grade level where in substantially separate programs or public and private day schools there is a specific emphasis on goals created truly to the students individualized needs based on the true performance. The difference between bringing a student to where you think he or she should be versus creating a goal that starts where the student truly is.",
      active: false,
    },
    {
      id: "paraprofessionals-roles-and-responsibilities",
      name: "Paraprofessionals: Roles & Responsibilities",
      status: "coming soon",
      authors: [authors.TBD],
      publishDate: "TBD",
      categories: ["Training Strategies", "Elective"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Leaders",
        "Parents",
      ],
      playlistIndex: null,
      pdPoints: 2,
      description:
        "This topic will discuss the importance of special ed aides, their roles, responsibilities, and difficulties, and how to build independence in our students using the Gradual Release of Responsibility.",
      active: false,
    },
    {
      id: "urban-education",
      name: "Urban Education",
      status: "coming soon",
      authors: [authors.TBD],
      publishDate: "TBD",
      categories: ["Pedagogy", "Elective"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Leaders",
        "Parents",
      ],
      playlistIndex: null,
      pdPoints: 2,
      description:
        "To equip educators with the knowledge, skills, and culturally responsive strategies necessary to effectively teach and support students in urban school settings, while enhancing instructional engagement across diverse educational populations.",
      active: false,
    },
    {
      id: "special-education-coaching",
      name: "Special Education Coaching: A Model of Support.",
      status: "published",
      authors: [authors.URBAN_DISTRICT_MID_LEVEL_TEAM],
      publishDate: "Nov 25th",
      categories: [
        "Subject Matter Knowledge",
        "Elective",
        "Training Strategies",
        "Pedagogy",
      ],
      learnerTypes: ["Special Educators", "Related Service Providers"],
      playlistIndex: null,
      pdPoints: 2,
      description:
        "In this topic, Pamela Lang-Moszka, Dawnmarie Reardon, Gabriella Masse, and Grace Kerr, members of an Urban District Mid-level Leadership Team, share the model they are implementing in their district, explain the benefits it provides, and offer guidance on how you can adopt a similar approach in your own—while highlighting their role as Special Education coaches supporting staff across the district.",
      active: true,
      sections: [
        {
          id: "part-1",
          type: "video",
          name: "Part 1: Our Model",
          description:
            "In this topic, Pamela Lang-Moszka, Dawnmarie Reardon, Gabriella Masse, and Grace Kerr, members of an Urban District Mid-level Leadership Team, share the model they are implementing in their district, explain the benefits it provides, and offer guidance on how you can adopt a similar approach in your own—while highlighting their role as Special Education coaches supporting staff across the district.",
          videoLength: "23:05",
          videoUrl: "https://vimeo.com/video/1140015728",
          playlistIndex: 1,
        },
        {
          id: "part-2",
          type: "video",
          name: "Part 2: Our Background",
          description:
            "In this topic, Pamela Lang-Moszka, Dawnmarie Reardon, Gabriella Masse, and Grace Kerr, members of an Urban District Mid-level Leadership Team, share the model they are implementing in their district, explain the benefits it provides, and offer guidance on how you can adopt a similar approach in your own—while highlighting their role as Special Education coaches supporting staff across the district.",
          videoLength: "09:45",
          videoUrl: "https://vimeo.com/video/1140016508",
          playlistIndex: 2,
        },
        {
          id: "part-3",
          type: "video",
          name: "Part 3: Implementing an Alternative Model",
          description:
            "In this topic, Pamela Lang-Moszka, Dawnmarie Reardon, Gabriella Masse, and Grace Kerr, members of an Urban District Mid-level Leadership Team, share the model they are implementing in their district, explain the benefits it provides, and offer guidance on how you can adopt a similar approach in your own—while highlighting their role as Special Education coaches supporting staff across the district.",
          videoLength: "19:45",
          videoUrl: "https://vimeo.com/video/1140016858",
          playlistIndex: 3,
        },
      ],
    },
    {
      id: "mtss-a-systems-view",
      name: "MTSS: A Systems View",
      authors: [authors.REBECCA, authors.MICHAEL],
      status: "published",
      publishDate: "Dec 30th",
      categories: ["Subject Matter Knowledge", "Elective"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Leaders",
        "Parents",
      ],
      playlistIndex: null,
      pdPoints: 2,
      description:
        "Multi-Tiered Systems (MTSS) obstacles, and implementation will be discussed through multiple lenses throughout this course: administrative (representing central office/building principal), general education (representing teachers), special education (special education teacher), and related services (representing SLP, BCBA, OT, PT, Social Worker/Adjustment Counselor). The team of content specialist will discuss various scenarios, situations, and hot topics related to the MTSS, in order to develop an understanding of the ways districts can implement interventions in a fluid and unique way.",
      active: true,
      sections: [
        {
          id: "we-are-the-mtss-team",
          type: "video",
          name: '"We" are the MTSS Team',
          description: "Part 1 of the MTSS: A Systems View topic.",
          videoLength: "05:05",
          videoUrl: "https://vimeo.com/video/1148908699",
          playlistIndex: 1,
        },
        {
          id: "iep-and-rti-can-exist-at-the-same-time",
          type: "video",
          name: "IEP & RTI can exist at the same time",
          description: "Part 2 of the MTSS: A Systems View topic.",
          videoLength: "2:25",
          videoUrl: "https://vimeo.com/video/1148908610",
          playlistIndex: 2,
        },
        {
          id: "mtss-is-a-plane",
          type: "video",
          name: "MTSS is a plane",
          description: "Part 3 of the MTSS: A Systems View topic.",
          videoLength: "15:50",
          videoUrl: "https://vimeo.com/video/1148908255",
          playlistIndex: 3,
        },
        {
          id: "sustaining-the-system",
          type: "video",
          name: "Sustaining the system",
          description: "Part 4 of the MTSS: A Systems View topic.",
          videoLength: "16:30",
          videoUrl: "https://vimeo.com/video/1148907817",
          playlistIndex: 4,
        },
        {
          id: "the-concept-of-we",
          type: "video",
          name: 'The concept of "we"',
          description: "Part 5 of the MTSS: A Systems View topic.",
          videoLength: "21:16",
          videoUrl: "https://vimeo.com/video/1148907230",
          playlistIndex: 5,
        },
      ],
    },
    {
      id: "interdisciplinary-collaboration-in-specialized-programs",
      name: "Interdisciplinary Collaboration in Specialized Programs",
      authors: [authors.COLLEEN, authors.KATIE],
      status: "published",
      publishDate: "Jan 27th",
      categories: ["Subject Matter Knowledge", "Elective"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
      ],
      playlistIndex: null,
      pdPoints: 0.25,
      description:
        "In this video, our team explore what meaningful collaboration looks like in specialized programs. Drawing from real classroom experience, they discuss why students with complex needs require team based problem solving, and how collaboration across disciplines leads to better access, stronger IEPs, and more responsive instruction. Through concrete examples, they highlight how teams can work together to identify the root of student challenges and support skill development across settings.",
      active: true,
      sections: [
        {
          id: "interdisciplinary-collaboration-in-specialized-programs",
          type: "video",
          name: "Interdisciplinary Collaboration in Specialized Programs",
          description: "Colleen and Katie discuss the importance of interdisciplinary collaboration in specialized programs.",
          videoLength: "06:20",
          videoUrl: "https://vimeo.com/video/1158468385",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "honoring-student-voices-in-specialized-programs",
      name: "Honoring Student Voices in Specialized Programs",
      authors: [authors.COLLEEN, authors.KATIE],
      status: "published",
      publishDate: "Jan 27th",
      categories: ["Subject Matter Knowledge", "Elective"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Parents",
      ],
      playlistIndex: null,
      pdPoints: 0.25,
      description:
        "Two special education teachers discuss the importance of honoring how students with disabilities choose to identify themselves. They reflect on person first and identity first language, the value of belonging in specialized classrooms, and the need to focus on student strengths and personal goals. They also talk about respecting how students view and name their own communication systems, especially for nonspeaking students who use AAC.",
      active: true,
      sections: [
        {
          id: "honoring-student-voices-in-specialized-programs",
          type: "video",
          name: "Honoring Student Voices in Specialized Programs",
          description: "Two special education teachers discuss the importance of honoring how students with disabilities choose to identify themselves. They reflect on person first and identity first language, the value of belonging in specialized classrooms, and the need to focus on student strengths and personal goals. They also talk about respecting how students view and name their own communication systems, especially for nonspeaking students who use AAC.",
          videoLength: "04:25",
          videoUrl: "https://vimeo.com/video/1158468194",
          playlistIndex: 1,
        },
      ],
    },
    {
      id: "cultural-and-systemic-factors-in-school",
      name: "Cultural & Systemic Factors in School",
      authors: [authors.BILL, authors.MARIAH],
      status: "published",
      publishDate: "Feb 24th",
      categories: ["Pedagogy"],
      learnerTypes: [
        "Special Educators",
        "General Educators",
        "Related Service Providers",
        "Parents",
        "Leaders",
      ],
      playlistIndex: null,
      pdPoints: 0.5,
      description:
        "This lesson explores the cultural realities and systemic factors that shape students' experiences in school. It examines how identity, representation, trauma, immigration, and current events influence learning, belonging, and classroom dynamics. Rather than focusing on isolated strategies, this session builds a foundational understanding of the contexts students bring with them each day and the responsibility educators hold in creating respectful, inclusive environments.",
      active: true,
      sections: [
        {
          id: "cultural-and-systemic-factors-in-school",
          type: "video",
          name: "Cultural & Systemic Factors in School",
          description: "This lesson explores the cultural realities and systemic factors that shape students' experiences in school. It examines how identity, representation, trauma, immigration, and current events influence learning, belonging, and classroom dynamics. Rather than focusing on isolated strategies, this session builds a foundational understanding of the contexts students bring with them each day and the responsibility educators hold in creating respectful, inclusive environments. Sources and External References: Blume Academy integrates research, journalism, and educational tools to deepen understanding of complex social and educational issues. The following resources are referenced in this training for context and continued learning. These materials are cited for educational context and reflection. Blume does not reproduce full articles or third party materials. Readers are encouraged to visit the original sources for complete information. Wheel of Privilege, created by Pasha Marlowe: This visual tool supports conversation around identity and systems. Learn more about the creator's work at https://pashamarlowe.com/wheel-of-privilege/",
          videoLength: "19:40",
          videoUrl: "https://vimeo.com/video/1167288337",
          playlistIndex: 1,
        },
      ],
    },
  ],
};

@State<AcademyStateModel>({
  name: 'academy',
  defaults,
})
@Injectable()
export class AcademyState implements NgxsOnInit {
  constructor() {}

  ngxsOnInit(ctx: StateContext<AcademyStateModel>): void {
    // Can add initialization logic here if needed
  }

  @Selector()
  static allCourses(state: AcademyStateModel): AcademyCourse[] {
    return state.courses.filter((course) => course.active);
  }

  /**
   * Get a course by ID (factory selector)
   */
  static getCourseById(id: string) {
    return createSelector([AcademyState], (state: AcademyStateModel) => {
      return state.courses.find((c) => c.id === id && c.active);
    });
  }

  /**
   * Get a section by course ID and section ID (factory selector)
   */
  static getSectionById(courseId: string, sectionId: string) {
    return createSelector([AcademyState], (state: AcademyStateModel) => {
      const course = state.courses.find((c) => c.id === courseId && c.active);
      return course?.sections?.find((s) => s.id === sectionId);
    });
  }
}
